import styled from 'styled-components';

export const AddEllipsisToTextOverflow = styled.div<{ hasBoldText?: boolean; maxWidth: string }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: ${({ hasBoldText = false }) => (hasBoldText ? 'var(--heading-sm)' : 'var(--body-sm)')};
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
`;
